import Component from '../abstracts/Component';
import { toggleTabIndex } from "../utils/FocusableElementUtils";

export default class NotifyMeComponent extends Component {

  get SELECTORS() {
    return {
      notifyBtn: '.js-addtocart.form-sumbmit',
      form: '.js-notify-me',
      container: '.js-form-container'
    };
  }

  get CLASSES() {
    return {
      formSubmit: 'form-sumbmit',
      show: 'show'
    };
  }

  constructor() {
    super();
  }

  enableForm(code, baseCode) {
    let formContainer = $(`${this.SELECTORS.container}[data-code="${baseCode}"]`);
    formContainer.removeAttr('tabindex');
    toggleTabIndex(formContainer, true);
    let form = formContainer.find(this.SELECTORS.form);
    form.find('#productcode').val(code);
    this.log('open notify form...');
    formContainer.addClass(this.CLASSES.show);
  }

  disableForm(baseCode) {
    let formContainer = $(`${this.SELECTORS.container}[data-code="${baseCode}"]`);
    formContainer.attr('tabindex', '-1');
    toggleTabIndex(formContainer, false);
    this.log('close notify form...');
    formContainer.removeClass(this.CLASSES.show);
  }

  submitForm() {

    let ctx = this;
    let $notifyBtn = $(this.SELECTORS.notifyBtn);
    let $form = $(this.SELECTORS.form);
    let url = $form.attr('action');
    let error = $form.find('.js-email-error');

    let previusText = $notifyBtn.html();
    $notifyBtn.html('');
    if ($form.find('#email').val()) ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
      button: $notifyBtn
    })

    $.ajax({
      type: "POST",
      url: url,
      data: $form.serialize(),
      success: function (message) {
        ctx.log('u\'ll be notified');
        // nascondi il loader
        // ripristina l'html precedente
        setTimeout(() => {
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
            button: $notifyBtn
          })
          $notifyBtn.attr('data-notified', true);
          $notifyBtn.attr('data-selected-size', '');
          let text = $notifyBtn.attr('data-msg-notified');
          $notifyBtn.html(text);
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeclose, $notifyBtn);
          // reset select for
          $('.js-variant-list').val(null).trigger('change');
          error.remove();
        }, 2000);

      },
      error: function (xhr) {
        ctx.log('notifyMe submit error ');
        $form.closest(ctx.SELECTORS.container).find('.js-message').removeClass('hidden').addClass('notify-message').text(xhr.responseText);
        $notifyBtn.html(previusText);
      }
    });
  }

  notifyValidation(){
    if($(this.SELECTORS.form).find('#email').val()){
      // if($(this.SELECTORS.form).find('.js-wrapper-privacy')[0].checked){
      this.submitForm();
      // }else{
      //   this.log('failed privacy validation');
      //   let errorText = $(this.SELECTORS.notifyBtn).attr('data-privacy-validation');
      //   $(this.SELECTORS.notifyBtn).first().text(errorText);
      // }
    }else{
      this.log('failed email validation');
      let errorText = $(this.SELECTORS.notifyBtn).attr('data-email-validation');
      $(this.SELECTORS.notifyBtn).first().text(errorText);
    }
  }

  bindEvents() {

    let ctx = this;

    $('body').on('submit', ctx.SELECTORS.form, function (e) {
      e.preventDefault();
      ctx.log('form submit on input enter');
      ctx.notifyValidation();
    });

    ctx.$on(ctx.$customEvents.PRODUCT_EVENTS.notifyme, ({
      event,
      payload
    }) => {
      let $btn = $(payload);
      $btn.addClass(ctx.CLASSES.formSubmit);

      $btn.on('click.submitNotify', (e) => {
        if($btn.attr('data-notified') != "true"){
          ctx.log('form submit on click');
          ctx.notifyValidation();
        }
      });

      let baseCode = $btn.attr('data-base-code');
      let code = $btn.attr('data-code');
      ctx.enableForm(code, baseCode);
    });

    ctx.$on(ctx.$customEvents.PRODUCT_EVENTS.notifymeclose, ({
      event,
      payload
    }) => {
      let $btn = $(payload);
      $btn.removeClass(ctx.CLASSES.formSubmit);

      $btn.off('click');

      let baseCode = $btn.attr('data-base-code');
      ctx.disableForm(baseCode);
    });

    //check per unique size non disponibile
    let $uniqueSizeUnavailable = $('.product-actions:not(.is-cart-bar) .js-addtocart[data-unique-size="true"][data-enabled="false"]')
    if($uniqueSizeUnavailable.length){
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifyme, $uniqueSizeUnavailable);
    }else{
      // disable notify me module from tabbing at landing
      toggleTabIndex($('.js-form-container'), false);
    }
  }

  render() {
    this.bindEvents();
  }
}
